<template>
 <a-tabs defaultActiveKey="1">
    <a-tab-pane key="1" v-if="firstTabDataSource">
      <span slot="tab">
        <a-icon type="file" />
        {{firstTabName}}
      </span>
      <a-list itemLayout="horizontal" :dataSource="firstTabDataSource">
        <a-list-item slot="renderItem" slot-scope="item" bordered="true">
          <a-list-item-meta>
            <router-link
            :to="{ name: 'course-details', params: { courseId: item.id } }"
            slot="title">
            <div v-html="item.title.rendered"></div>
            </router-link>
          </a-list-item-meta>
          <a-tag color="green">
            Submitted Date: {{ item.post_meta.courseSubmissionDateString[0] }}
          </a-tag>
          <a-tag color="blue" v-if="userRole === 'telas_admin'">
            Submitted By: {{ item.author_name }}
          </a-tag>
        </a-list-item>
      </a-list>
    </a-tab-pane>
    <a-tab-pane key="2" v-if="secondTabDataSource">
      <span slot="tab">
        <a-icon type="file" />
        {{secondTabName}}
      </span>
      <a-list itemLayout="horizontal" :dataSource="secondTabDataSource">
        <a-list-item slot="renderItem" slot-scope="item">
          <router-link
            slot="actions"
            :to="{ name: 'course-details', params: { courseId: item.id } }"
            v-if="item.assesment_data['assigned_' + item.assesment_data.current_assessment_level + '_status'] === 'completed'"
          >
            <a-button
            block
            type="dashed"
            >
              Assign Reviewer
            </a-button>
          </router-link>
          <router-link
            slot="actions"
            :to="{ name: 'assessment-details', params: { assessmentId: item.assesment_data[ 'assigned_' + item.assesment_data.current_assessment_level + '_assessment_id'] } }"
            v-else
          >
            <a-button
              block
              type="dashed"
            >
              View Assessment
            </a-button>
          </router-link>
          <a-list-item-meta>
            <router-link
            :to="{ name: 'course-details', params: { courseId: item.id } }"
            slot="title">
              <div v-html="item.title.rendered"></div>
            </router-link>
          </a-list-item-meta>
          <a-tag color="green" style="text-transform: capitalize;" v-if="item.assesment_data['assigned_' + item.assesment_data.current_assessment_level + '_status'] === 'in-progress'">
            {{ item.assesment_data.current_assessment_level | replaceUnderscore | removeEr}}: {{ item.assesment_data['assigned_' + item.assesment_data.current_assessment_level + '_status']  }}
          </a-tag>
          <a-tag color="red" style="text-transform: capitalize;" v-else>
            {{ item.assesment_data.current_assessment_level | replaceUnderscore | removeEr}}: {{ item.assesment_data['assigned_' + item.assesment_data.current_assessment_level + '_status']  }}
          </a-tag>
        </a-list-item>
      </a-list>
    </a-tab-pane>
    <a-tab-pane key="3" v-if="thirdTabDataSource">
      <span slot="tab">
        <a-icon type="file" />
        {{thirdTabName}}
      </span>
      <a-list itemLayout="horizontal" :dataSource="thirdTabDataSource">
        <a-list-item slot="renderItem" slot-scope="item">
          <a-list-item-meta>
            <router-link
            :to="{ name: 'course-details', params: { courseId: item.id } }"
            slot="title">
              <div v-html="item.title.rendered"></div>
            </router-link>
          </a-list-item-meta>
          <router-link
            :to="{ name: 'comparative-summary', params: { 'courseId': item.id } }"
          >
            <a-tag color="green">
              View Summary
            </a-tag>
          </router-link>
        </a-list-item>
      </a-list>
    </a-tab-pane>
    <a-tab-pane key="4" v-if="fourthTabDataSource">
      <span slot="tab">
        <a-icon type="file" />
        {{fourthTabName}}
      </span>
      <a-list itemLayout="horizontal" :dataSource="fourthTabDataSource">
        <a-list-item slot="renderItem" slot-scope="item">
          <a-list-item-meta>
            <router-link
            :to="{ name: 'course-details', params: { courseId: item.id } }"
            slot="title">
              <div v-html="item.title.rendered"></div>
            </router-link>
          </a-list-item-meta>
          <router-link
            :to="{ name: 'course-details', params: { 'courseId': item.id } }"
          >
            <a-tag color="green" v-if="item.assesment_data.assigned_admin_reviewer_status.length > 0 && item.assesment_data.assigned_admin_reviewer_status === 'completed'">
              Assign Interim Reviewer
            </a-tag>
            <a-tag color="green" v-else>
              Assign Admin Reviewer
            </a-tag>
          </router-link>
        </a-list-item>
      </a-list>
    </a-tab-pane>
  </a-tabs>
</template>
<script>
export default {
  name: 'courses-list-admin-tab',
  data() {
    return {
    };
  },
  props: [
    'firstTabName',
    'firstTabDataSource',
    'secondTabName',
    'secondTabDataSource',
    'thirdTabName',
    'thirdTabDataSource',
    'userRole',
    'fourthTabName',
    'fourthTabDataSource',
  ],
  created() {
  },
  methods: {
  },
};
</script>
